import React from 'react';

const ThreeStepsSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Procure the autologous material',
      icon: 'https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/74e9pr3u_image.png'
    },
    {
      number: '02',
      title: 'Insert into the MCT Kit®',
      icon: 'https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/8ciwusay_image.png'
    },
    {
      number: '03',
      title: 'Set up the MCT Unit®',
      icon: 'https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/dvbadyfm_image.png'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4" style={{ fontFamily: 'Raleway, sans-serif' }}>
            The <span className="text-teal-500 font-normal">3 easy steps</span>
          </h2>
        </div>

        {/* Steps grid */}
        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 shadow-soft hover:shadow-xl transition-all duration-500 hover:-translate-y-2"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Step number badge */}
              <div className="absolute -top-4 left-8 bg-gradient-to-r from-teal-400 to-teal-500 text-white px-5 py-2 rounded-full text-sm font-medium shadow-lg">
                Step {step.number}
              </div>

              {/* Icon */}
              <div className="flex justify-center mb-8 mt-4">
                <div className="w-32 h-32 flex items-center justify-center">
                  <img 
                    src={step.icon} 
                    alt={`Step ${step.number}`}
                    className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl md:text-2xl font-light text-center text-gray-900 leading-snug">
                {step.title}
              </h3>

              {/* Bottom accent line */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-400 to-teal-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 rounded-b-3xl"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThreeStepsSection;
